import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  changed(event) {
    const level = parseInt(event.params.level)
    const surveyId = event.params.surveyId

    // Collect selections up to and including the changed level
    const selects = this.element.querySelectorAll('select')
    const selections = []
    for (let i = 0; i <= level; i++) {
      const val = selects[i]?.value
      if (val) selections.push(val)
      else break
    }

    const frame = this.element.closest('turbo-frame')
    const url = `/time_study/activity_codes?survey_id=${surveyId}&selections=${selections.join(',')}`
    frame.src = url
  }
}
